import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.less']
})
export class ErrorComponent {
  @Input() isMobile: boolean;
  @Input() errorMessage: string;
  @Output() isClosed = new EventEmitter<boolean>();

  onDismiss() {
    this.isClosed.emit(true);
  }
}
